import { CartResponse, IUserCart } from '@legalzoom/cart-sdk';

export interface CartState {
    cartId: number;
    cart: IUserCart;
    cartResponse: CartResponse;
}
export function createCartState({
    cartId = null,
    cart = null,
    cartResponse = null,
}: Partial<CartState>) {
    return {
        cartId,
        cart,
        cartResponse,
    };
}
